import { deleteBusinessOperation } from "../../../../actions/Utilities/BusinessOperation";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";

const useDeleteBusinessOperation = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteBusinessOperation(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetBusinessOperation"]);
      toast.fire(
        "Success",
        "Business Operation has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Business Operation",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteBusinessOperation;
